import { render, staticRenderFns } from "./ProductPriceTable.vue?vue&type=template&id=e1f3804c&scoped=true&lang=html"
import script from "./ProductPriceTable.vue?vue&type=script&lang=js"
export * from "./ProductPriceTable.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceTable.vue?vue&type=style&index=0&id=e1f3804c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f3804c",
  null
  
)

export default component.exports